import { render, staticRenderFns } from "./SuperAdminCertSearch.vue?vue&type=template&id=00c31fe6&scoped=true"
import script from "./SuperAdminCertSearch.vue?vue&type=script&lang=js"
export * from "./SuperAdminCertSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c31fe6",
  null
  
)

export default component.exports